import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import "./styles.css";
import "./SuccessfullyAuthenticated.css";

export interface ISuccessfullyAuthenticatedState extends ITeamsBaseComponentState {
    message: string;
    error: string;
    errordescription: string;
    retryLink: string;
}

export interface ISuccessfullyAuthenticatedProps {}

export class SuccessfullyAuthenticated extends TeamsBaseComponent<
    ISuccessfullyAuthenticatedProps,
    ISuccessfullyAuthenticatedState
> {
    constructor(props: ISuccessfullyAuthenticatedProps) {
        super(props);
        this.state = {
            theme: null,
            message:
                this.getQueryVariable("admin_consent") != null
                    ? "Permissions Successfully Granted"
                    : "Successfully Authenticated",
            error: this.getQueryVariable("error") != null ? this.getQueryVariable("error").replace(/\+/g, " ") : null,
            errordescription:
                this.getQueryVariable("error_description") != null
                    ? this.getQueryVariable("error_description").replace(/\+/g, " ")
                    : null,
            retryLink: this.getQueryVariable("retryLink"),
        };
    }

    public async componentDidMount() {
        if (this.state.error == null) {
            microsoftTeams.initialize(() => {
                microsoftTeams.authentication.notifySuccess();
            });
        }
    }

    public render() {
        return (
            <div className="center error-width">
                <p className="text-center font-heading">
                    <img src={"/content/intapplogo.png"} width={100} height={100} className="vertical-middle" />{" "}
                    Intapp Content Connector
                </p>
                {this.state.error == null && (
                    <p className="text-center font-subheading">{this.state.message}</p>
                )}
                {this.state.error != null && <p className="text-center font-subheading">{this.state.error}</p>}
                {this.state.error != null && (
                    <p className="text-center error-description">{this.state.errordescription}</p>
                )}
                {this.state.retryLink != null && (
                    <p className="text-center">
                        <br></br>
                        <a href={this.state.retryLink}>Retry Login</a>
                    </p>
                )}
                <br></br>
                <p className="text-center error-description">You can close this window now.</p>
            </div>
        );
    }
}
